import { Outlet } from 'react-router-dom'

import { Root } from './styles'
import Nav from './Nav'

const Layout = () => {
  return (
    <Root>
      <Nav />
      <Outlet />
    </Root>
  )
}

export default Layout
